import styled from '@emotion/styled';
import { Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

export const SmallGrayText = styled.p`
  ${Typography.smallPrint1}
  color: ${Colors.neutral700};
`;

export const SmallText = styled.p`
  line-height: 20px;
  font-size: 14px;
  font-weight: 600;
`;

export const MediumGrayText = styled.p`
  color: ${Colors.neutral700};
  ${Typography.paragraph3}
  ${mediaQueries.tablet} {
    ${Typography.paragraph1Short}
  }
`;

export const LargeBlackText = styled.h1`
  color: ${Colors.neutral800};
  font-size: 28px;
  line-height: 120%;
  ${Typography.pageHeader9}
  ${mediaQueries.tablet} {
    ${Typography.pageHeader3}
  }
`;

export const MediumBlackText = styled.h1`
  color: ${Colors.neutral800};
  ${Typography.pageHeader9}
  ${mediaQueries.tablet} {
    ${Typography.pageHeader3}
  }
`;

export const CommonLinkText = styled(SmallText)`
  text-decoration: underline;
  color: ${Colors.blueJeans};

  &:hover,
  :focus,
  :focus-within {
    color: ${Colors.blueJeans};
  }
`;
